<template>
  <div class="shadow-card mb-3" style="position: relative">
    <div :style="{ display: 'flex', alignItems: 'center' }">
      <div style="position: relative">
        <a-avatar
          @click="() => viewProfile()"
          :style="{
            color: ' #ffffff !important',
            backgroundColor: revieweeData.image
              ? ''
              : reviewData.review_color
              ? `#${reviewData.review_color}`
              : getAvatarColor(revieweeData.id),
            fontSize: '18px',
            fontWeight: '700'
          }"
          :src="revieweeData.image"
          alt="profile_image"
          :size="70"
          class="text-capitalize cp"
        >
          {{ revieweeData.name ? revieweeData.name[0] : "D" }}
        </a-avatar>
        <a-avatar
          :style="{
            color: ' #ffffff !important',
            backgroundColor: reviewData.author.picture ? '' : getAvatarColor(),
            fontSize: '8px  !important',
            fontWeight: '900',
            position: 'absolute',
            right: 0,
            bottom: 0,
            borderColor: 'white',
            borderWidth: '1px',
            borderStyle: 'solid'
          }"
          :src="reviewData.author.picture"
          alt="profile_image"
          :size="24"
          class="text-capitalize avatar-badge"
        >
          {{ reviewData.author.username ? reviewData.author.username[0] : "" }}
        </a-avatar>
      </div>
      <div :style="{ flex: 1, 'margin-left': '16px' }">
        <div class="mobile-view">
          <p class="text-name m-0 pr-2 cp" @click="() => viewProfile()">
            {{ revieweeData.name || "User" }}
          </p>
          <span class="text-reviewed">
            <font-awesome-icon
              class="font18 text-black mr-2"
              :icon="['fal', 'star']"
            />has been reviewed</span
          >
        </div>
        <!-- <p class="text-day">{{ time }}</p> -->
        <p
          class="text-day"
          :style="{
            display: 'flex',
            ColumnGap: '2px',
            flexWrap: 'wrap'
          }"
        >
          <span class="text-name-2 pr-1">
            by
            {{ !reviewData.review_delete_url ? "Verified user" : "you" }}</span
          >{{ time }}
        </p>
      </div>
      <div class="cont">
        <p
          v-if="reviewType"
          class="text-day br8 fw700 py-1 px-2"
          :style="{
            color: getPrimaryColor(),
            background: getPrimary50Color(),
            marginLeft: 0,
            textAlign: 'center',
            width: 'fit-content'
          }"
        >
          {{
            reviewType === "InPerson"
              ? "In person visit"
              : reviewType === "Online"
              ? "Online TeleMedicine"
              : reviewType === "MyCircles"
              ? "MyCircles"
              : reviewType
          }}
        </p>
        <div
          class="star-cont"
          :style="{ marginTop: !reviewType ? 'auto' : '8px' }"
        >
          <div class="str-grp">
            <ReviewStar
              :rating="Number(parseFloat(reviewData.overall).toFixed(1))"
              :height="24"
              :width="24"
            />
            <p class="review-text">
              {{ parseFloat(reviewData.overall).toFixed(1) }}
            </p>
          </div>
          <font-awesome-icon
            v-if="!expand"
            @click="expand = !expand"
            class="cp gray400 font24"
            :icon="['fas', 'angle-down']"
          />
          <font-awesome-icon
            v-if="expand"
            @click="expand = !expand"
            class="cp gray400 font24"
            :icon="['fas', 'angle-up']"
          />
        </div>
      </div>
    </div>
    <a-divider
      v-if="expand"
      class="divider-line"
      type="horizontal"
      style="margin: 16px 0px"
    />
    <a-divider
      class="divider-line-mob"
      type="horizontal"
      style="margin: 16px 0px"
    />
    <div class="cont-mob">
      <p
        v-if="reviewType"
        class="text-day"
        :style="{
          color: getPrimaryColor(),
          background: getPrimary50Color(),
          marginLeft: 0,
          textAlign: 'center',
          borderRadius: '4px',
          width: 'fit-content',
          padding: '0px 8px'
        }"
      >
        {{
          reviewType === "InPerson"
            ? "In person visit"
            : reviewType === "Online"
            ? "Online TeleMedicine"
            : reviewType === "MyCircles"
            ? "MyCircles"
            : reviewType
        }}
      </p>
      <div class="star-cont">
        <div class="str-grp">
          <ReviewStar
            :rating="Number(parseFloat(reviewData.overall).toFixed(1))"
            :height="24"
            :width="24"
          />
          <p class="review-text">
            {{ parseFloat(reviewData.overall).toFixed(1) }}
          </p>
        </div>
        <div style="flex: 1"></div>
        <font-awesome-icon
          v-if="!expand"
          @click="expand = !expand"
          class="cp gray400 font24"
          :icon="['fas', 'angle-down']"
        />
        <font-awesome-icon
          v-if="expand"
          @click="expand = !expand"
          class="cp gray400 font24"
          :icon="['fas', 'angle-up']"
        />
      </div>
    </div>
    <div v-if="expand">
      <p
        class="review-description"
        :style="{
          marginBottom: reviewData.comment
            ? reviewData.comment.length > 150
              ? '0px'
              : '16px'
            : '0px'
        }"
        v-html="
          seeMore
            ? getLimitedDescription(reviewData.comment)
            : reviewData.comment
        "
      ></p>
      <div v-if="reviewData.comment">
        <p
          style="padding: 16px 0px"
          v-if="reviewData.comment.length > 150 && seeMore"
          @click="seeMore = !seeMore"
        >
          <span class="see-more">see more</span>
        </p>
        <!-- <p
          style="padding: 16px 0px"
          v-if="reviewData.comment.length > 150 && !seeMore"
          @click="seeMore = !seeMore"
        >
          <span class="see-more">see less</span>
        </p> -->
      </div>
      <div class="rate-box-container">
        <div
          class="rate-box"
          v-for="(item, index) in rating_list"
          v-if="rating_value_list[index]"
        >
          {{ item }}
          <div class="d-flex">
            <ReviewStar
              :rating="Number(rating_value_list[index])"
              :height="16"
              :width="16"
            />
            <span
              v-if="rating_value_list[index]"
              :style="{
                color: getPrimaryColor()
              }"
              v-html="getRating(rating_value_list[index])"
            ></span>
          </div>
        </div>
        <div class="rate-box" v-if="reviewData['length_of_visit']">
          Length of Visit
          <span
            :style="{
              color: getPrimaryColor()
            }"
            >{{ getFullLength(reviewData["length_of_visit"]) }}</span
          >
        </div>
      </div>
      <div
        style="display: flex; justify-content: space-between; align-items: flex-end"
      >
        <div class="footer-container">
          <p class="footer-text">Was this review helpful?</p>
          <p>
            <font-awesome-icon
              v-if="reviewData.review_create_helpful_url"
              :icon="['fal', 'thumbs-up']"
              class="like-button"
              @click="reactReview('like')"
            />
            <font-awesome-icon
              v-else
              class="like-button"
              :icon="['fas', 'thumbs-up']"
              :style="{
                color: getPrimaryColor()
              }"
              @click="reactReview('like')"
            />
            <font-awesome-icon
              v-if="reviewData.review_create_unhelpful_url"
              :icon="['fal', 'thumbs-down']"
              style="margin-left: 20px; cursor: pointer"
              @click="reactReview('dislike')"
            />
            <font-awesome-icon
              v-else
              class="like-button"
              :icon="['fas', 'thumbs-down']"
              :style="{
                marginLeft: '20px',
                color: getPrimaryColor(),
                cursor: 'pointer'
              }"
              @click="reactReview('dislike')"
            />
          </p>
        </div>
        <p
          class="footer-text"
          style="cursor: pointer"
          @click="reactReview('flag')"
          v-if="
            reviewData.review_create_flag_url ||
              reviewData.review_delete_flag_url
          "
        >
          <span>
            <font-awesome-icon
              v-if="reviewData.review_create_flag_url"
              :icon="['fal', 'flag']"
              style="margin-right: 10px"
            />
            <font-awesome-icon
              v-else
              :icon="['fas', 'flag']"
              :style="{ marginRight: '10px', color: getPrimaryColor() }"
            />
          </span>
          Flag Review
        </p>
      </div>
    </div>
    <button
      v-if="showAllreviewsButton"
      class="view-button"
      :style="{ color: getPrimaryColor() }"
      @click="routeToReceivedReviews"
    >
      View all reviews
    </button>
    <div v-if="loadingScreen" class="spinnerContainer-post">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFilter,
  faStar,
  faFlag,
  faThumbsDown,
  faThumbsUp,
  faAngleDown,
  faAngleUp
} from "@fortawesome/pro-solid-svg-icons";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";
import ReviewStar from "../../commons/ReviewStar.vue";

const UserRepository = RepositoryFactory.get("user");
const ReviewsRepository = RepositoryFactory.get("reviews");

library.add(
  faFilter,
  faFlag,
  faStar,
  faThumbsDown,
  faThumbsUp,
  faAngleDown,
  faAngleUp
);

export default {
  name: "ReviewCard",

  props: {
    reviewData: Object,
    type: String,
    showAllreviewsButton: {
      default: false,
      type: Boolean
    }
  },
  components: {
    ReviewStar
  },

  data() {
    return {
      review: null,
      image: null,
      name: null,
      title: null,
      reviewType: null,
      rating_list: [
        "Clarity",
        "Friendliness Of The Staff",
        "Nursing Care",
        "Courtesy Of Stuff",
        "Cleanliness",
        "Community Service",
        "Ease of Appointment",
        "Wait Time",
        "Friendliness Of The Staff",
        "Attentiveness",
        "Quality Time",
        "Politeness",
        "Knowledge"
      ],
      rating_value_list: [],
      expand: false,
      time: "",
      description: null,
      seeMore: true,
      reaction: { flag: false, like: false, dislike: false },
      like_id: null,
      dislike_id: null,
      flag_id: null,
      loadingScreen: false,
      revieweeData: null,
      my_circles_id: null
    };
  },

  created() {
    this.revieweeData = this.getReviewee();
    this.time = this.formatPostTime(this.reviewData.published);
    this.review = this.reviewData;
    if (this.type === "physician" || this.type === "ohcp") {
      this.reviewType = "InPerson";
    }
    this.rating_value_list.push(
      this.reviewData.clarity,
      this.reviewData.friendliness_of_staff,
      this.reviewData.nursing_care,
      this.reviewData.courtesy_of_stuff,
      this.reviewData.cleanliness,
      this.reviewData.community_service,
      this.reviewData.appointment,
      this.reviewData.wait_time,
      this.reviewData.friendliness,
      this.reviewData.attentiveness,
      this.reviewData.quality_time,
      this.reviewData.politeness,
      this.reviewData.knowledge
    );
  },
  methods: {
    getFullLength(len) {
      const LENGTHS = {
        lt15: "Less than 30 minutes",
        lt30: "30 - 60 minutes",
        hour: "More than an hour"
      };
      return LENGTHS[len];
    },
    getAllRatings() {
      this.allRatings.forEach(eachRate => {
        if (this.reviewData[eachRate.key]) {
          this.individualRatings.push({
            name: eachRate.name,
            value: parseFloat(this.reviewData[eachRate.key]).toFixed(1)
          });
        }
      });
    },
    getReviewee() {
      if (this.type === "clinic") {
        return {
          name: this.reviewData.clinic_info.clinic_name,
          image: this.reviewData.clinic_info.picture,
          id: this.reviewData.clinic_info.id,
          ratingLink: this.reviewData.clinic_info.profile_link
        };
      } else if (this.type === "hospital") {
        return {
          name: this.reviewData.hospital_info.hospital_name,
          image: this.reviewData.hospital_info.picture,
          id: this.reviewData.hospital_info.id,
          ratingLink: this.reviewData.hospital_info.profile_link
        };
      } else if (this.type === "physician") {
        return {
          name:
            this.reviewData.physician_info.full_name +
            (this.reviewData.physician_info.title
              ? `, ${this.reviewData.physician_info.title}`
              : ""),
          image: this.reviewData.physician_info.picture,
          id: this.reviewData.physician_info.id,
          ratingLink: this.reviewData.physician_info.profile_link
        };
      } else if (this.type === "ohcp") {
        return {
          name:
            this.reviewData.app_info.full_name +
            (this.reviewData.app_info.title
              ? `, ${this.reviewData.app_info.title}`
              : ""),
          image: this.reviewData.app_info.picture,
          id: this.reviewData.app_info.id,
          ratingLink: this.reviewData.app_info.profile_link
        };
      }
      return {
        name: "D",
        id: 0,
        image: null,
        ratingLink: "www.dovemed.com"
      };
    },
    formatPostTime(value) {
      const d = new Date(value);
      const now = new Date();
      const seconds = Math.round(
        Math.abs((now.getTime() - d.getTime()) / 1000)
      );
      const minutes = Math.round(Math.abs(seconds / 60));
      const hours = Math.round(Math.abs(minutes / 60));
      const days = Math.round(Math.abs(hours / 24));
      const months = Math.round(Math.abs(days / 30.416));
      const years = Math.round(Math.abs(days / 365));
      if (this.isDateToday(d)) {
        return "Today";
      }
      if (Number.isNaN(seconds)) {
        return "";
      } else if (seconds <= 45) {
        return "a few seconds ago";
      } else if (seconds <= 90) {
        return "a minute ago";
      } else if (minutes <= 45) {
        return minutes + " minutes ago";
      } else if (minutes <= 90) {
        return "an hour ago";
      } else if (hours <= 22) {
        return hours + " hours ago";
      } else if (hours <= 36) {
        return "a day ago";
      } else if (days <= 25) {
        return days + " days ago";
      } else if (days <= 45) {
        return "a month ago";
      } else if (days <= 345) {
        return months + " months ago";
      } else if (days <= 545) {
        return "a year ago";
      } else {
        // (days > 545)
        return years + " years ago";
      }
    },
    getLimitedDescription(description) {
      const div = document.createElement("div");
      div.innerHTML = description;
      const text = div.textContent || div.innerText || "";

      return text.length > 150 ? text.substring(0, 150) + "..." : text;
    },
    getRating(rating) {
      return parseFloat(rating).toFixed(1);
    },
    async reactReview(type) {
      try {
        const headers = {
          Authorization: `Basic ${btoa("dovemed:dovemed-rules")}`,
          dtoken:
            this.authUser.user.dovemed_csrf_token ||
            this.authUser.user.dovemed_session_token
        };
        switch (type) {
          case "flag":
            if (this.reviewData.review_create_flag_url) {
              await this.$http.post(
                `${process.env.SSO_BASE_URL}/api/v2/review/${this.type}/review/${this.reviewData.id}/flag/`,
                null,
                { headers }
              );
              this.reviewData.review_create_flag_url = false;
              this.reviewData.review_delete_flag_url = true;
              this.$notification.success({
                message: "Successful",
                description: `Flag saved`
              });
            } else if (this.reviewData.review_delete_flag_url) {
              await this.$http.delete(
                `${process.env.SSO_BASE_URL}/api/v2/review/${this.type}/review/${this.reviewData.id}/flag/`,
                { headers }
              );
              this.reviewData.review_create_flag_url = true;
              this.reviewData.review_delete_flag_url = false;
              this.$notification.success({
                message: "Successful",
                description: `Flag unsaved`
              });
            }
            break;
          case "like":
            if (this.reviewData.review_create_helpful_url) {
              await this.$http.post(
                `${process.env.SSO_BASE_URL}/api/v2/review/${this.type}/review/${this.reviewData.id}/helpful/`,
                null,
                { headers }
              );
              this.reviewData.review_create_helpful_url = false;
              this.reviewData.review_delete_helpful_url = true;
              this.reviewData.review_delete_unhelpful_url = false;
              this.reviewData.review_create_unhelpful_url = true;
              //if (this.reviewData.review_delete_unhelpful_url) {
              //  this.reactReview("dislike");
              //}
              this.$notification.success({
                message: "Successful",
                description: `Helpful saved`
              });
            } else if (this.reviewData.review_delete_helpful_url) {
              await this.$http.delete(
                `${process.env.SSO_BASE_URL}/api/v2/review/${this.type}/review/${this.reviewData.id}/helpful/`,
                { headers }
              );
              this.reviewData.review_create_helpful_url = true;
              this.reviewData.review_delete_helpful_url = false;
              this.$notification.success({
                message: "Successful",
                description: `Helpful unsaved`
              });
            }
            break;
          case "dislike":
            if (this.reviewData.review_create_unhelpful_url) {
              await this.$http.post(
                `${process.env.SSO_BASE_URL}/api/v2/review/${this.type}/review/${this.reviewData.id}/unhelpful/`,
                null,
                { headers }
              );
              this.reviewData.review_create_unhelpful_url = false;
              this.reviewData.review_delete_unhelpful_url = true;
              this.reviewData.review_create_helpful_url = true;
              this.reviewData.review_delete_helpful_url = false;
              //if (this.reviewData.review_delete_helpful_url) {
              //  this.reactReview("like");
              // }
              this.$notification.success({
                message: "Successful",
                description: `Unhelpful saved`
              });
            } else if (this.reviewData.review_delete_unhelpful_url) {
              await this.$http.delete(
                `${process.env.SSO_BASE_URL}/api/v2/review/${this.type}/review/${this.reviewData.id}/unhelpful/`,
                { headers }
              );
              this.reviewData.review_create_unhelpful_url = true;
              this.reviewData.review_delete_unhelpful_url = false;
              this.$notification.success({
                message: "Successful",
                description: `Unhelpful unsaved`
              });
            }
            break;
        }
      } catch (e) {
        this.$notification.error({
          message: "Error",
          description: "Please try again later."
        });
      }
    },
    getRole() {
      if (this.type === "clinic") {
        return "clinic_administrator";
      } else if (this.type === "hospital") {
        return "hospital_administrator";
      } else if (this.type === "physician") {
        return "doctor";
      } else if (this.type === "ohcp") {
        return "hcp";
      }
    },
    async getID() {
      await ReviewsRepository.getMyCircleID(
        this.currentCircle.id,
        this.revieweeData.id,
        this.getRole()
      )
        .then(res => {
          if (res.data.data.hasOwnProperty("my_circles_id")) {
            this.my_circles_id = res.data.data.my_circles_id;
          } else {
            this.my_circles_id = null;
          }
        })
        .catch(err => {});
    },
    async viewProfile() {
      this.loadingScreen = true;
      await this.getID();
      if (!this.my_circles_id) {
        this.routeProfile();
      } else {
        this.profile();
      }
    },
    profile() {
      this.loadingScreen = true;
      if (
        this.my_circles_id === this.authUser.user.id &&
        this.getRole() === this.authUser.user.role
      ) {
        this.routeToAuthProfile(this.authUser.user.role);
      } else {
        UserRepository.getOtherUserProfile(
          { id: this.my_circles_id, role: this.getRole() },
          this.currentCircle.id
        )
          .then(res => {
            const data = {
              ...res.data.data.user_info,
              on_circle: res.data.data.on_circle,
              request_to_add: res.data.data.request_to_add,
              no_of_members: res.data.data.no_of_members,
              recommendations: res.data.data.no_of_recommendations,
              recommend: res.data.data.recommend,
              overall_rating: res.data.data.overall_rating
                ? res.data.data.overall_rating
                : res.data.data.rating,
              inPersonReview: res.data.data.in_person_visit,
              onlineReview: res.data.data.online_tele_medicine,
              myCirclesReview: res.data.data.my_circle
            };
            this.$store.commit("User/setViewUser", { data });
            switch (this.getRole()) {
              case "doctor":
              case "physician":
                this.$router.push({
                  name: "ViewDoctorUpdates",
                  params: { id: this.my_circles_id }
                });
                break;
              case "clinic_administrator":
                this.$router.push({
                  name: "ViewClinicAbout",
                  params: { id: this.my_circles_id }
                });
                break;
              case "hospital_administrator":
                this.$router.push({
                  name: "ViewHos_adminAbout",
                  params: { id: this.my_circles_id }
                });
                break;
              case "nfp":
                this.$router.push({
                  name: "ViewNfpAbout",
                  params: { id: this.my_circles_id }
                });
                break;
              case "patient":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: this.my_circles_id }
                });
                break;
              case "caregiver":
                this.$router.push({
                  name: "ViewPatientUpdates",
                  params: { id: this.my_circles_id, role: "caregiver" }
                });
                break;
              case "advocate":
                this.$router.push({
                  name: "ViewAdvocateAbout",
                  params: { id: this.my_circles_id }
                });
                break;
              case "hospital":
                this.$router.push({
                  name: "HospViewAbout",
                  params: { id: this.my_circles_id }
                });
                break;
              case "clinic":
                this.$router.push({
                  name: "ClinicViewAbout",
                  params: { id: this.my_circles_id }
                });
              case "nfp_administrator":
                this.$router.push({
                  name: "ViewNfpAdminAbout",
                  params: { id: this.my_circles_id }
                });
                break;
              case "hcp":
                this.$router.push({
                  name: "ViewHcpAbout",
                  params: { id: this.my_circles_id }
                });
                break;
              default:
                break;
            }
          })
          .catch(err => {
            this.loadingScreen = false;
          });
      }
    },
    routeProfile(
      reviewee_role = this.getRole(),
      reviewee_id = this.revieweeData.id
    ) {
      this.loadingScreen = true;
      switch (reviewee_role) {
        case "physician":
        case "providers":
        case "doctor":
          this.viewEntityProfile({
            role: "doctor",
            id: reviewee_id
          });
          break;
        case "other":
        case "hcp":
        case "hcp_administrator":
          this.viewEntityProfile({ role: "hcp", id: reviewee_id });
          break;
        case "hospital":
        case "hospital_administrator":
          this.viewEntityProfile({
            role: "hospital",
            id: reviewee_id
          });
          break;
        case "clinic":
        case "clinic_administrator":
          this.viewEntityProfile({ role: "clinic", id: reviewee_id });
          break;
        case "nfp":
        case "nfp_administrator":
          this.viewEntityProfile({ role: "nfp", id: reviewee_id });
          break;
        case "Business":
          break;
      }
    },
    async routeToReceivedReviews() {
      await this.getID();
      const routeID = this.my_circles_id
        ? this.my_circles_id
        : this.revieweeData.id;
      this.loadingScreen = true;
      if (
        routeID === this.authUser.user.id &&
        this.getRole() === this.authUser.user.role
      ) {
        this.routeToAuthProfile(this.authUser.user.role);
      } else {
        if (!this.my_circles_id) {
          UserRepository.getOtherEntityProfile(
            { role: this.getRole(), ext_ref_id: routeID },
            this.currentCircle.id
          )
            .then(res => {
              this.$store.commit("User/setViewUser", {
                data: {
                  ...res.data.data,
                  role: this.getRole(),
                  isDirectory: true
                }
              });
              this.$router.push({
                path: `/${
                  this.currentCircle.key_name
                }/profile/view/${this.getRole()}/${routeID}/receivedreviews/all`
              });
            })
            .catch(err => {});
        } else {
          UserRepository.getOtherUserProfile(
            { id: routeID, role: this.getRole() },
            this.currentCircle.id
          )
            .then(res => {
              const data = {
                ...res.data.data.user_info,
                on_circle: res.data.data.on_circle,
                request_to_add: res.data.data.request_to_add,
                no_of_members: res.data.data.no_of_members,
                recommendations: res.data.data.no_of_recommendations,
                recommend: res.data.data.recommend,
                overall_rating: res.data.data.overall_rating
                  ? res.data.data.overall_rating
                  : res.data.data.rating,
                inPersonReview: res.data.data.in_person_visit,
                onlineReview: res.data.data.online_tele_medicine,
                myCirclesReview: res.data.data.my_circle
              };
              this.$store.commit("User/setViewUser", { data });
              this.$router.push({
                path: `/${
                  this.currentCircle.key_name
                }/profile/view/${this.getRole()}/${routeID}/receivedreviews/all`
              });
            })
            .catch(err => {
              this.loadingScreen = false;
            });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-view {
  display: flex;
  // margin-left: 16px;
  flex-wrap: wrap;
  flex-direction: column;
  // flex-direction: row;
}
.text-name {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
  margin-left: 16px;
  margin-bottom: 4px;
  text-transform: capitalize;
  width: fit-content;
}

.text-day {
  // font-weight: 400;
  font-size: 12px;
  color: #94a3b8;
  // margin-left: 16px;
  margin-bottom: 0px;
}

.cont {
  display: flex;
  flex-direction: column;
  // gap: 8px;
  @media screen and (max-width: 900px) {
    display: none;
  }
  align-self: stretch;
}

.cont-mob {
  display: none;
  // display: flex;
  // flex-direction: column;
  // gap: 8px;
  @media screen and (max-width: 900px) {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}

.text-name-2 {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
  margin-bottom: 4px;
}
.text-reviewed {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
  text-transform: none;
  white-space: nowrap;
  padding-right: 10px;
  .icon {
    width: 24px;
  }
}

.text-link {
  @media only screen and (max-width: 500px) {
    display: none;
  }
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
}
.view-button {
  @media only screen and (min-width: 501px) {
    // display: none;
  }
  background: #f1f5f9;
  border-radius: 8px;
  padding: 8px;
  width: 100%;
  margin-top: 16px;
  border: none;
  font-weight: 700;
  font-size: 14px;
}
.str-grp {
  display: flex;
  gap: 8px;
  height: 24px;
  align-items: center;
}
.star-cont {
  display: flex;
  // gap: 24px;
  gap: 16px;
  align-items: center;
}
.review-text {
  font-weight: 700;
  font-size: 16px;
  color: #0f1734;
  // margin-left: 8px;
}

.star-container {
  width: 24px;
  height: 24px;
  border-radius: 2px;
}

.review-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #647490;
  padding-top: 16px;
}

.see-more {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #94a3b8;
  cursor: pointer;
}

.rate-box-container {
  display: flex;
  row-gap: 16px;
  column-gap: 8px;
  flex-wrap: wrap;
  padding-bottom: 30px;
  @media only screen and (max-width: 500px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

.rate-box {
  font-weight: 700;
  font-size: 12px;
  color: #0f1734;
  background: #f1f5f9;
  border-radius: 8px;
  padding: 8px;
  text-align: center;
  text-transform: capitalize;
  display: flex;
  gap: 8px;
  align-items: center;
  @media only screen and (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
    text-align: start;
  }
}

.footer-container {
  display: flex;
  @media only screen and (max-width: 500px) {
    flex-direction: column;
    gap: 24px;
  }
}

.footer-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1734;
}
.like-button {
  margin-left: 20px;
  @media only screen and (max-width: 500px) {
    margin-left: 0px;
  }
  cursor: pointer;
}
.divider-line {
  @media only screen and (max-width: 900px) {
    display: none;
  }
}
.divider-line-mob {
  @media only screen and (min-width: 901px) {
    display: none;
  }
}
.spinnerContainer-post {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.2);
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/reviews/ReviewTabCoreCard.vue